import React, { useState, useEffect, useMemo } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { payCommissions } from '../../flux/actions/commissionpaymentActions';
import { IAuthReduxProps, IConfirmCommissionPaymentComponent, ITarget } from '../../types/interfaces';

import { useAlert } from "react-alert";
import { E_ERROR } from '../../types/errors';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCheckCircle, faExclamationTriangle, faSpinner} from '@fortawesome/free-solid-svg-icons'
import moment from "moment";
import PDFLink from '../pdf/PDFLink';
import { constants } from '../../types/constants';

const ConfirmCommissionPayment = ({ 
  payCommissions,
  linesData,
  auth,
  clearInputs,
  selectedUser,
  societeValue,
  commentValue,
  setClearFilters
  }: IConfirmCommissionPaymentComponent) => {
  const alert = useAlert();
  const [modal, setModal] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  
  const handleToggle = () => setModal(!modal);

  const modalClosedHandle = () => {
    if(reEnable){
      // setSelectedRows([]);
      clearInputs();
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const callback = (success) => {
    if(success){
      setReEnable(true);
      setModal(false);
      if(alert.removeAll && typeof alert.removeAll === "function")
        alert.removeAll()
      alert.success("Paiement validé", {timeout: 0});
      // alert.success("Paiement ajouté au panier", {open: `/fiche_paiement/${success.id}`, timeout: 0});
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const confirmPaymentHandle = async action => {
    if(!action){
      alert.error(E_ERROR.NO_ACTION);
      return
    }
    if(!selectedUser){
      alert.error("Veuillez sélectionner un commercial");
      return
    }
    if(action === constants.VALIDATE_CHECK)
      setClearFilters(true)
    if(linesData.length === 0){
      alert.error("Veuillez sélectionner au moins une ligne");
      return
    }
    if(linesData.filter(e => !e.left && e.toPay !== 0).length){
      alert.error("Veuillez saisir un montant");
      return
    }
    if(action === constants.VALIDATE_CHECK){
      setModal(true);
      return
    }
    else if(action === constants.VALIDATE_CONFIRM){
      setDisableSubmit(true);
      payCommissions(linesData, selectedUser.id, commentValue, auth?.user?.id, callback, action === constants.VALIDATE_CONFIRM_AND_PRINT);
      return
    }
    // return {...paymentInfo, payment_lines: linesData.map(e => ({date_fac: e.date_fac, NFacture: e.NFacture, total_ttc: e.total_ttc, total_ttc_paid: e.total_ttc_left, facture_lines: e.facture_lines})), fournisseur: selectedUser}
  }
  
  return (
    <>
      <Container className="confirmDiv" fixed="down">
        <Row className="justify-content-center">
          <Col xs="12" sm="6">
            <FormGroup>
              <Button
                className="btn btn-success confirmBtn"
                onClick={() => confirmPaymentHandle(constants.VALIDATE_CHECK)}
                ><FontAwesomeIcon icon={faCheckCircle} />&nbsp;&nbsp;{linesData.length ? `Payer ${linesData.length === 1 ? "le" : `les ${linesData.length}`} bulletin${linesData.length === 1 ? "" : "s"}\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0${linesData.reduce((e, t) => {return t.left ? e + t.left : e}, 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH TTC` : `Payer`}</Button>
            </FormGroup>
          </Col>
        </Row>
      </Container>

      <Modal isOpen={modal} toggle={handleToggle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faExclamationTriangle} />&nbsp;&nbsp;Confirmation du Paiement</ModalHeader>
        <ModalBody>
          <Container className="linesConfirmationContainer">
            <Row className="linesConfirmationRow">
              <Col xs="12" sm="6" className="fullFlexCenter">Date du Paiement : </Col><Col xs="12" sm="6" className="linesConfirmationValue fullFlexCenter">{moment().format('DD/MM/YYYY')}</Col>
            </Row>
            {/* <Row className="linesConfirmationRow">
              <Col xs="12" sm="6">Commerciaux : </Col><Col xs="12" sm="6" className="linesConfirmationValue">{linesData.map(e => (e.bulletinComUser && e.bulletinComUser["LOGIN"]) || "-").join(", ")}</Col>
            </Row> */}
            {linesData.map((e, key) => (
              <Row className="linesConfirmationLines" key={key}>
                <Col xs="12"><b>{(e.bulletinComUser && e.bulletinComUser["LOGIN"]) || "-"}</b> - Bulletin N° <b>{e.id || "-"}</b></Col>
                <Col xs="12">Paiement de <b>{(e.left || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</b>{e.left !== e.left_table && <>&nbsp;sur <b>{e.left_table ? e.left_table.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"} DH</b></>}</Col>
              </Row>
            ))}
            <Row>
              <Button
                className="btn btn-success linesConfirmationBtn"
                onClick={() => confirmPaymentHandle(constants.VALIDATE_CONFIRM)}
                disabled={disableSubmit}
                ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Valider</Button>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
      </>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth
});

export default connect(mapStateToProps, { payCommissions })(ConfirmCommissionPayment);
